import { type BulkPromoStatus, type JobAction } from '@/types';

export const getButtonLabel = (jobAction: JobAction, jobStatus: BulkPromoStatus): string => {
    const complete = ['complete', 'complete-with-errors'];

    if (jobStatus === 'processing') {
        return `Processing...`;
    }

    if (jobAction === 'export' && complete.includes(jobStatus)) {
        return 'Download';
    }

    return 'Export';
};
